import React from 'react';
import { notifyNetworkError, notifyInfo } from '@/utils/notify';
const NetworkMonitor = () => {
    React.useEffect(() => {
        const onOffline = () => notifyNetworkError('offline', { title: '网络已断开', message: '请检查网络连接', sticky: true });
        const onOnline = () => notifyInfo('online', { title: '网络已恢复', message: '您现在已连接到互联网', autoCloseMs: 2500 });
        window.addEventListener('offline', onOffline);
        window.addEventListener('online', onOnline);
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            onOffline();
        }
        return () => {
            window.removeEventListener('offline', onOffline);
            window.removeEventListener('online', onOnline);
        };
    }, []);
    return null;
};
export default NetworkMonitor;
